module.exports = require("react-sound-visualizer");